import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { LibraryModel } from '../models'

export interface SupplierType extends LibraryModel {
    new?: boolean
}
export const disabledColumnOptions = new Map<string, string>([
    ['true', 'Disabled'],
    ['false', 'Enabled']
])
export const url = '/libraries/management/types/supplierType/entries'

@Injectable()
export class SupplierTypeService {
    constructor(private http: HttpService) {}
    getAll(): Observable<SupplierType[]> {
        return this.http.get<SupplierType[]>(url)
    }

    remove(data: SupplierType[]): Observable<void> {
        return this.http.delete(url + '/', { data })
    }

    create(data: SupplierType[]): Observable<SupplierType[]> {
        return this.http.post<SupplierType[]>(url, { data })
    }
    update(data: SupplierType[]): Observable<SupplierType[]> {
        return this.http.put<SupplierType[]>(url, { data })
    }
}
